var React = require('react');

function Sd (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h682.7v512H0z"}))),React.createElement("g",{"fillRule":"evenodd","strokeWidth":"1pt","clipPath":"url(#a)","transform":"scale(.9375)","key":1},[React.createElement("path",{"d":"M0 341.3h1024V512H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 170.6h1024v170.7H0z","key":1}),React.createElement("path",{"fill":"red","d":"M0 0h1024.8v170.7H0z","key":2}),React.createElement("path",{"fill":"#009a00","d":"M0 0v512l341.3-256L0 0z","key":3})])]);
}

Sd.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Sd;

Sd.default = Sd;
